var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-settings-sliders",
    opacity: 0.5,
    clipPath: "url(#clip0_7389_10735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.87771 8.90762H7.0072C8.0196 12.6326 11.86 14.8316 15.5849 13.8192C17.9773 13.1689 19.8462 11.3 20.4965 8.90762H43.1236C44.159 8.90762 44.9984 8.06826 44.9984 7.03283C44.9984 5.99741 44.159 5.15805 43.1236 5.15805H20.4965C19.4841 1.433 15.6437 -0.76598 11.9187 0.246419C9.52634 0.896657 7.65744 2.76555 7.0072 5.15796H1.87771C0.84229 5.15796 0.00292969 5.99732 0.00292969 7.03274C0.00292969 8.06817 0.84229 8.90762 1.87771 8.90762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.1236 20.6256H37.9941C36.9837 16.9012 33.1455 14.701 29.421 15.7113C27.0267 16.3608 25.1562 18.2312 24.5067 20.6256H1.87771C0.84229 20.6256 0.00292969 21.465 0.00292969 22.5004C0.00292969 23.5358 0.84229 24.3752 1.87771 24.3752H24.5067C25.5171 28.0996 29.3553 30.2998 33.0797 29.2896C35.4741 28.64 37.3446 26.7696 37.9941 24.3752H43.1236C44.159 24.3752 44.9984 23.5358 44.9984 22.5004C44.9984 21.465 44.159 20.6256 43.1236 20.6256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M43.1236 36.0925H20.4965C19.4841 32.3676 15.6437 30.1686 11.9187 31.181C9.52634 31.8312 7.65744 33.7001 7.0072 36.0925H1.87771C0.84229 36.0925 0.00292969 36.9319 0.00292969 37.9673C0.00292969 39.0027 0.84229 39.8421 1.87771 39.8421H7.0072C8.0196 43.567 11.86 45.766 15.5849 44.7536C17.9773 44.1034 19.8462 42.2345 20.4965 39.8421H43.1236C44.159 39.8421 44.9984 39.0027 44.9984 37.9673C44.9984 36.9319 44.159 36.0925 43.1236 36.0925Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7389_10735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingEdit);
export default __webpack_public_path__ + "static/media/setting-edit.7548dfdf68ffbe04e8bd079dba02a530.svg";
export { ForwardRef as ReactComponent };